import rootStores from "@/Stores/RootStores";

export const useStoreMobx = () => {
    return rootStores;
};
